"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFontSchema = exports.IFontRenderSettingsSchema = void 0;
const zod_1 = require("zod");
exports.IFontRenderSettingsSchema = zod_1.default.object({
    heightRatio: zod_1.default.number(),
    fontRenderScale: zod_1.default.number(),
    fontRenderOffset: zod_1.default.tuple([zod_1.default.number(), zod_1.default.number()]),
    startChar: zod_1.default.number(),
    unknownChar: zod_1.default.string(),
    italicTilt: zod_1.default.number(),
    charSpacing: zod_1.default.number(),
    overbarSpacing: zod_1.default.number(),
    underlineSpacing: zod_1.default.number(),
    interlineRatio: zod_1.default.number(),
});
exports.IFontSchema = exports.IFontRenderSettingsSchema.extend({
    glyphs: zod_1.default.string().array(),
});
//# sourceMappingURL=Fonts.js.map